import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderStatus } from 'src/app/api/models/order-status';
import { SplitChildOrderDetail } from 'src/app/api/models/split-child-order-detail';

@Component({
    selector: 'app-confirm-reception-dialog',
    templateUrl: './confirm-reception-dialog.component.html',
    styleUrls: ['./confirm-reception-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmReceptionDialogComponent {
  public childOrders: SplitChildOrderDetail[];

  constructor(
    public dialogRef: MatDialogRef<ConfirmReceptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: { childOrders: SplitChildOrderDetail[] }
  ) {
    this.childOrders = data.childOrders;
  }

  confirmReception(child: SplitChildOrderDetail) {
    this.dialogRef.close(child.id);
  }
}